import React, { Fragment } from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import Header from '../../components/Header'
import hero from '../../images/attractions-and-transportation__hero.jpg'
import img01 from '../../images/attractions-1.jpg'
import img02 from '../../images/attractions-2.jpg'
import img03 from '../../images/attractions-3.jpg'

const Page = () => (
  <Fragment>
    <Helmet
      title="Attractions & Transportation | What We Offer"
      // meta={[{ name: 'description', content: '' }]}
    />
    <Header hero={hero}>
      <h1 className="t-hero">
        Attractions & <br />
        Transportation
      </h1>
    </Header>
    <main id="content">
      <div className="c-golden t-context--light">
        <div className="c-golden__images c-golden__short min-laptop">
          <div style={{ width: '50%', height: '100%' }}>
            <img src={img01} alt="" style={{ width: '100%', height: '50%' }} />
            <img src={img02} alt="" style={{ width: '100%', height: '50%' }} />
          </div>
          <img src={img03} alt="" style={{ width: '50%', height: '100%' }} />
        </div>
        <div className="c-golden__content c-golden__wide">
          <ul className="c-breadcrumbs mb30">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/what-we-offer">What We Offer</Link>
            </li>
            <li>
              <Link
                to="/what-we-offer/attractions-and-transportation"
                activeClassName="is-active"
              >
                Attractions & Transportation
              </Link>
            </li>
          </ul>
          <div className="c-golden__text">
            <div className="c-golden__text-col">
              <h1 className="t-h1">
              Your one-stop-shop for attractions & transportation services
              </h1>
              <p className="t-p t-p-light mt30">
                With a team of product managers dedicated to contracting local
                attractions, and other unique experiences in destinations across
                North America, ATI offers preferred rates for individual and
                group tickets to popular theme parks, local sightseeing tours,
                Broadway and Las Vegas shows, as well as access to more
                experiential activities like mountain biking excursions, food
                and wine tastings, and white water rafting to name a few. We can
                also get you anywhere you want to go with our network of seat-in
                and private transportation providers in every North American
                gateway destination and beyond.
              </p>
            </div>
          </div>
        </div>
      </div>
    </main>
  </Fragment>
)

export default Page



// WEBPACK FOOTER //
// ./src/pages/what-we-offer/attractions-and-transportation.js